// extracted by mini-css-extract-plugin
module.exports = {"answerText":"unlockedAnswerText_answerText__ZkONB"};